import { marketingConversationSchema } from "@redotech/redo-model/marketing/marketing-conversation/marketing-conversation-definition";
import * as z from "zod/v4";

export const getConversations = {
  name: "getConversations" as const,
  input: z.object({
    limit: z.number().int().positive().max(100).default(20),
    paginationKey: z.string().optional(),
  }),
  output: z.object({
    conversations: z.array(marketingConversationSchema),
    paginationKey: z.string().optional(),
  }),
};
